// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-container {
  width: 50%;
  padding-left: 35px;
}
.task-container .custom-card {
  margin-top: 16px;
  padding: 24px;
}
.task-container .custom-card ol li {
  font-size: 16px;
  list-style-type: decimal;
  padding-top: 16px;
}
.task-container .custom-card ol li:first-child {
  padding-top: 0;
}

@media only screen and (min-width: 0px) and (max-width: 1024px) {
  .task-container {
    padding-left: 16px;
  }
  .task-container .custom-card ol li {
    padding-top: 10px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 768px) {
  .task-container {
    width: 100%;
    padding-left: 0;
    padding-top: 40px;
  }
}
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .task-container {
    padding-top: 24px;
  }
  .task-container .custom-card ol li {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/TaskList/TaskList.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,kBAAA;AACJ;AAAI;EACE,gBAAA;EACA,aAAA;AAEN;AAAQ;EACE,eAAA;EACA,wBAAA;EACA,iBAAA;AAEV;AADU;EACE,cAAA;AAGZ;;AAGE;EACE;IACE,kBAAA;EAAJ;EAGY;IACI,iBAAA;EADhB;AACF;AAME;EACE;IACE,WAAA;IACA,eAAA;IACA,iBAAA;EAJJ;AACF;AAME;EACE;IACE,iBAAA;EAJJ;EAOY;IACI,eAAA;EALhB;AACF","sourcesContent":[".task-container{\r\n    width: 50%;\r\n    padding-left: 35px;\r\n    .custom-card{\r\n      margin-top: 16px;\r\n      padding: 24px;\r\n      ol{\r\n        li{\r\n          font-size: 16px;\r\n          list-style-type: decimal;\r\n          padding-top: 16px;\r\n          &:first-child{\r\n            padding-top: 0;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 1024px) {\r\n    .task-container{\r\n      padding-left: 16px;\r\n      .custom-card{\r\n          ol{\r\n              li{\r\n                  padding-top: 10px;\r\n              }\r\n          }\r\n      }\r\n    }\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 768px) {\r\n    .task-container{\r\n      width: 100%;\r\n      padding-left: 0;\r\n      padding-top: 40px;\r\n    }\r\n  }\r\n  @media only screen and (min-width: 0px) and (max-width: 767px) {\r\n    .task-container{\r\n      padding-top: 24px;\r\n      .custom-card{\r\n          ol{\r\n              li{\r\n                  font-size: 12px;\r\n              }\r\n          }\r\n      }\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
